"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _FoodMenu = require("../../../FoodMenu.context");

var _index = require("../index");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

require("./Item.css");

var ItemContainer = function ItemContainer(_ref) {
  var itemId = _ref.itemId,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["itemId"]);
  return _react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var items = _ref2.items;

    var item = _menu["default"].getItemById(items, itemId);

    var id = item.id,
        name = item.name,
        description = item.description,
        image = item.image;
    return _react["default"].createElement(_FoodMenu.VariantConsumer, null, function (_ref3) {
      var itemDisplay = _ref3.itemDisplay;
      var ItemComponent = _index.displayVariantComponentMap.item[itemDisplay];
      return _react["default"].createElement(ItemComponent, (0, _extends2["default"])({
        isSingleVariation: _menu["default"].menuItemHasOneVariation(item),
        id: id,
        name: name,
        description: description,
        image: image,
        variations: _menu["default"].getMenuItemVariations(item)
      }, rest));
    });
  });
};

var _default = ItemContainer;
exports["default"] = _default;